import { render, staticRenderFns } from "./LaboralPage.vue?vue&type=template&id=3561edc6&"
import script from "./LaboralPage.vue?vue&type=script&lang=js&"
export * from "./LaboralPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports